import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';

// import { DndProvider } from 'react-dnd';
// import HTML5Backend from 'react-dnd-html5-backend';
// import update from 'immutability-helper';
// import DragableBodyRow from '@Component/Table/Row/DragableBodyRow';

import { Table, Pagination, Row, Col } from 'antd';

// const components = {
// 	body: {
// 		row: DragableBodyRow,
// 	},
// };

const CustomTable = memo(
	({
		tableName,
		isShowRowNumber,
		isPagination,
		currentPage,
		totalRecord,
		columns,
		scroll,
		data,
		onChangePage,
		rowKey,
		t,
		pageSize,
		// isDragableRow,
		onChangeRow,
		onChangeTable,
		rowSelection,
	}) => {
		const [defaultColumn, setDefaultColumn] = useState([]);

		useEffect(() => {
			if (scroll) {
				// document
				// .getElementById(tableName)
				// .getElementsByClassName('ant-table-body')[0]
				// .addEventListener(
				// 	'wheel',
				// 	(e) => {
				// 		onWheel(e);
				// 	},
				// 	{ passive: false }
				// );
			}
		}, []);

		useEffect(() => {
			if (isShowRowNumber) {
				setDefaultColumn([
					{
						align: 'center',
						key: 'rowNumber',
						width: '100px',
						title: 'ลำดับ',
						render: (text, record, index) => {
							return (currentPage - 1) * pageSize + (index + 1);
						},
					},
					...columns,
				]);
			} else {
				setDefaultColumn(columns);
			}
		}, [columns, isShowRowNumber, currentPage]);

		// const onWheel = (e) => {
		// 	e.preventDefault();
		// 	var container = document.getElementById(tableName).getElementsByClassName('ant-table-body')[0];
		// 	var containerScrollPosition = document
		// 		.getElementById(tableName)
		// 		.getElementsByClassName('ant-table-body')[0].scrollLeft;
		// 	container.scrollTo({
		// 		top: 0,
		// 		left: containerScrollPosition + e.deltaY,
		// 		behaviour: 'smooth', //if you want smooth scrolling
		// 	});
		// };

		return (
			<>
				<div id={tableName} className="table-scroll">
					{/* <DndProvider backend={HTML5Backend}> */}
					<Table
						columns={defaultColumn}
						dataSource={data}
						pagination={false}
						// bordered
						rowKey={rowKey}
						// components={isDragableRow ? components : undefined}
						onRow={onChangeRow ? onChangeRow : undefined}
						scroll={scroll}
						onChange={onChangeTable}
						rowSelection={rowSelection}
					/>
					{/* </DndProvider> */}
				</div>
				{isPagination && data && data.length > 0 ? (
					<Row className="mt-3 justify-content-end">
						<Col className="pt-2 me-3 text-center text-sm-left mb-3 mb-sm-0 showitem">
							{'Showing from: ' + ((currentPage - 1) * pageSize + 1) + ' to: '+ (totalRecord < 10 ? totalRecord : (currentPage - 1) * pageSize + pageSize) + ' of '+ (totalRecord)+ ' Entries '}
						</Col>
						<Col className="">
							<Pagination
								onChange={onChangePage}
								pageSize={pageSize}
								current={currentPage}
								total={totalRecord}
							/>
						</Col>
					</Row>
				) : null}
			</>
		);
	}
);
CustomTable.propTypes = {
	tableName: PropTypes.string.isRequired,
	onChangePage: PropTypes.func,
	onChangeRow: PropTypes.func,
	isShowRowNumber: PropTypes.bool,
	isPagination: PropTypes.bool,
	isDragableRow: PropTypes.bool,
	currentPage: PropTypes.number,
	totalRecord: PropTypes.number,
	scroll: PropTypes.object,
	columns: PropTypes.array.isRequired,
	data: PropTypes.array.isRequired,
	rowKey: PropTypes.string.isRequired,
	pageSize: PropTypes.number,
	onChangeTable: PropTypes.func,
	rowSelection: PropTypes.object,
};
CustomTable.defaultProps = {
	onChangePage: (page, pageSize) => {
		console.error(
			'Please set function onChangePage in CustomTable Component',
			`Page ${page}, PageSize ${pageSize}`
		);
	},
	isPagination: false,
	isShowRowNumber: true,
	currentPage: 1,
	totalRecord: undefined,
	pageSize: 10,
	isDragableRow: false,
	scroll: undefined,
	onChangeTable: undefined,
	rowSelection: undefined,
	onChangeRow: undefined,
};

export default (CustomTable);
